import _ from 'lodash';
import { useEffect, useRef, useMemo, useState } from 'react';

const DELAY_MS = 50;

/**
 * Each time <Waypoint/> is shown in the visible window area it invokes
 * given `onTrigger` method. It may be helpful e.g. when you implement
 * eternal pagination
 */
const Waypoint = ({ onTrigger }: { onTrigger: () => void }) => {
  const [domNode, setDomNode] = useState<HTMLDivElement | null>(null);

  const ref = useRef(domNode);
  ref.current = domNode;

  const tryTrigger = useMemo(
    () =>
      // to make `domNode` get its real position it's a good idea to have
      // some debounce here
      _.debounce(() => {
        if (!ref.current) return;

        const { top, bottom } = orDie(ref.current).getBoundingClientRect();
        if (top < 0 || bottom > window.innerHeight) return;

        onTrigger(); // e.g. fetch more items
      }, DELAY_MS),
    [onTrigger]
  );

  useEffect(() => {
    document.body.addEventListener('scroll', tryTrigger, {
      passive: true,
      capture: true,
    });
    return () =>
      document.body.removeEventListener('scroll', tryTrigger, {
        capture: true,
      });
  }, [tryTrigger]);

  useEffect(
    () => {
      tryTrigger();
    } /* each render */
  );

  return (
    <div
      ref={setDomNode}
      style={{ height: '1px', width: '1px', opacity: '0', marginTop: '-1px' }}
    />
  );
};

export default Waypoint; // no MEMO!
